import type { UseMutationResult } from "@tanstack/react-query";
import type { ListMutate } from "@shared/hooks/useListMutate";
import {
    usePerformBoOperationMutation,
    type PerformBoOperationVariables,
} from "@src/businessModules/WorkShop/shared/bo/usePerformBoOperationMutation";
import type { WsInplantContent } from "../../../../api/wsInplants";
import { useWsInplantContentMutations, type UseWsInplantContentMutationsResult } from "./useWsInplantContentMutations";

export interface UseWsInplantCardMutationsParams {
    contentMutate: ListMutate<WsInplantContent>;
    onBoOperationSuccess: () => void;
}

export interface UseWsInplantCardMutationsResult extends UseWsInplantContentMutationsResult {
    performBoOperationMutation: UseMutationResult<void, Error, PerformBoOperationVariables>;
}

/**
 * Screen-level мутации карточки ВЗН УП.
 */
export function useWsInplantCardMutations({
    contentMutate,
    onBoOperationSuccess,
}: UseWsInplantCardMutationsParams): UseWsInplantCardMutationsResult {
    const contentMutations = useWsInplantContentMutations({ contentMutate });

    const performBoOperationMutation = usePerformBoOperationMutation({
        scope: "wsInplant",
        onSuccess: onBoOperationSuccess,
    });

    return {
        ...contentMutations,
        performBoOperationMutation,
    };
}
